import { createContext } from 'react';
import { AccordionContextType } from '../state/accordionStore.types';

export const AccordionContext = createContext<AccordionContextType | undefined>(
	undefined,
);
